// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__q_YlB","desktopNav":"header_desktopNav__bZDOx","mobileNav":"header_mobileNav__uWS7i"};